import { IInsuranceOptionValue } from '@sondermind/utilities/models-provider-network-company';
import { IConcernOptionValue } from '../models/specialty';

export function compareSimpleTypeOptionValues(
  option1: unknown, option2: unknown
): boolean {
  return option1 === option2;
}

export function compareInsuranceValues(
  option1: IInsuranceOptionValue, option2: IInsuranceOptionValue
): boolean {
  return !!option1?.pncId
    && !!option2?.pncId
    && option1?.pncId === option2?.pncId;
}

export function compareConcernValues(
  option1: IConcernOptionValue, option2: IConcernOptionValue
): boolean {
  return !!option1?.id
    && !!option2?.id
    && option1?.id === option2?.id;
}
